import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { AdminDetailComponent } from "../../components/borrowSystem/AdminDetailComponent";
import { Footer } from "../../components/share/Footer";

export function AdminDetailContainer() {
  const titleName = "รายละเอียดคำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <AdminDetailComponent />
      <Footer />
    </div>
  );
}
